export default __webpack_public_path__ + "assets/images/Campaigns-dc621838e0c59b5d024144293ac57265.svg";